import { zhContent } from "@/content/zh";

export type Locale = "zh" | "en";

export const locales: Locale[] = ["zh", "en"];

export function toLocale(value: string | undefined): Locale {
  return value === "en" ? "en" : "zh";
}

export const routeMap = {
  home: "",
  serviceIntro: "services/introduction",
  guarantee: "services/guarantee",
  warehouse: "warehouse",
  process: "process",
  calculator: "tools/shipping-calculator",
  prealert: "tools/parcel-prealert",
  tracking: "tools/tracking",
  routes: "tools/routes",
  help: "help",
  guide: "guide",
  faq: "faq",
  news: "news",
  careers: "careers",
  contact: "contact",
  about: "about",
  register: "register",
  login: "login",
  legalServiceAgreement: "legal/service-agreement",
  legalPrivacyPolicy: "legal/privacy-policy",
  legalRestrictedItems: "legal/restricted-items",
  legalServiceGuarantee: "legal/service-guarantee"
} as const;

export type PageKey = keyof typeof routeMap;

export const pageKeys = Object.keys(routeMap) as PageKey[];

export const metadataByPage = zhContent.metadata;

export const navGroups = zhContent.chrome.nav;

export function localizedPath(locale: Locale, path = "") {
  return `/${locale}/${path}`.replace(/\/+$/, "/");
}

export function switchLocalePath(currentLocale: Locale, targetLocale: Locale, pathname: string) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] === currentLocale) parts[0] = targetLocale;
  return `/${parts.join("/")}/`;
}

export function pageKeyFromPath(path: string): PageKey {
  const normalized = path.replace(/^\/+|\/+$/g, "");
  const entry = pageKeys.find((key) => routeMap[key] === normalized);
  return entry ?? "home";
}
